import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { PageHeader } from "../components/Table";
import { FloppyDisk } from "@phosphor-icons/react";

const SEV_COLOR = { critical: "#FF3B30", warning: "#FF9500", operational: "#5AC8FA" };

export default function AlertRules() {
  const [meta, setMeta] = useState([]);
  const [rules, setRules] = useState({});
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    api.get("/alert-rules").then((r) => { setMeta(r.data.meta); setRules(r.data.rules); });
  }, []);

  const toggle = (key) => { setRules((r) => ({ ...r, [key]: !r[key] })); setDirty(true); };
  const save = async () => {
    const r = await api.put("/alert-rules", { rules });
    setRules(r.data.rules); setDirty(false); toast.success("Alert rules saved");
  };

  const groups = ["critical", "warning", "operational"];

  return (
    <div className="p-5 space-y-4 max-w-3xl">
      <PageHeader title="Alert Rules" subtitle="Choose which events trigger notifications"
        actions={<button data-testid="save-rules" onClick={save} disabled={!dirty}
          className="flex items-center gap-1.5 bg-primary text-white font-semibold text-sm px-4 py-2 rounded-sm disabled:opacity-50">
          <FloppyDisk size={15} weight="bold" /> Save Rules</button>} />

      {groups.map((g) => {
        const items = meta.filter((m) => m.severity === g);
        if (!items.length) return null;
        return (
          <div key={g} className="bg-card border border-border rounded-sm p-4">
            <div className="label-caps mb-3 flex items-center gap-2">
              <span className="status-dot" style={{ background: SEV_COLOR[g] }} /> {g}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {items.map((m) => (
                <button key={m.key} data-testid={`rule-${m.key}`} onClick={() => toggle(m.key)}
                  className={`flex items-center justify-between px-3 py-2.5 rounded-sm border text-sm ${rules[m.key] ? "border-primary bg-primary/10" : "border-border"}`}>
                  <span className="font-semibold">{m.label}</span>
                  <span className={`w-10 h-5 rounded-full relative transition-colors ${rules[m.key] ? "bg-primary" : "bg-secondary"}`}>
                    <span className={`absolute top-0.5 w-4 h-4 bg-white rounded-full transition-all ${rules[m.key] ? "left-[22px]" : "left-0.5"}`} />
                  </span>
                </button>
              ))}
            </div>
          </div>
        );
      })}
      <p className="text-xs text-muted-foreground">Disabled events keep appearing in reports/history but stop generating live notifications & alerts.</p>
    </div>
  );
}
